// src/components/Blog/BlogDetail.jsx
import React, { useState, useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import Navbar from '../Navbar/Navbar';
import Footer from '../Footer/Footer';
import '../Blog/Blog.css';
import { FiCalendar, FiArrowLeft, FiTag } from 'react-icons/fi';
import { doc, getDoc, collection, query, where, getDocs } from 'firebase/firestore';
import { db } from '../firebase/firebase-config';

function BlogDetail() {
  const { id } = useParams(); // URL'den gelen parametre (slug veya doc id)
  const [blog, setBlog] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchBlogDetail = async () => {
      try {
        // 1. Yöntem: Doğrudan Firebase Document ID ile bulmayı dene
        const docRef = doc(db, 'blogs', id);
        const docSnap = await getDoc(docRef);

        if (docSnap.exists()) {
          setBlog(docSnap.data());
          setLoading(false);
          return;
        }

        // 2. Yöntem: Eğer doc id değilse, özel 'id' (slug) alanında ara
        const q = query(collection(db, 'blogs'), where('id', '==', id));
        const querySnapshot = await getDocs(q);

        if (!querySnapshot.empty) {
          setBlog(querySnapshot.docs[0].data());
        } else {
          setBlog(null);
        }
      } catch (error) {
        console.error("Makale detayı çekilirken hata oluştu:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchBlogDetail();
    window.scrollTo(0, 0);
  }, [id]);

  return (
    <div className="page-wrapper">
      <Navbar />

      <div className="blog-detail-section" style={{ padding: '140px 0 80px 0' }}>
        <div className="container" style={{ maxWidth: '800px' }}>
          
          <Link to="/blog" className="back-to-blog-btn" style={{ display: 'inline-flex', alignItems: 'center', gap: '8px', color: 'var(--gold-primary)', marginBottom: '30px', textDecoration: 'none', fontWeight: '500' }}>
            <FiArrowLeft /> Tüm Makalelere Dön
          </Link>

          {loading ? (
            <div className="no-blog-box">
              <p>Makale yükleniyor...</p>
            </div>
          ) : !blog ? (
            <div className="no-blog-box">
              <h3>Makale Bulunamadı</h3>
              <p>Aradığınız makale silinmiş veya mevcut değil.</p>
            </div>
          ) : (
            <article className="blog-detail-card" style={{ background: 'linear-gradient(145deg, #131313 0%, #0a0a0a 100%)', border: '1px solid rgba(197, 160, 89, 0.2)', padding: '40px', borderRadius: '8px', boxShadow: '0 15px 35px rgba(0,0,0,0.6)' }}>
              
              <div className="blog-detail-meta" style={{ display: 'flex', gap: '20px', alignItems: 'center', marginBottom: '20px', color: 'var(--text-muted)', fontSize: '0.9rem' }}>
                <span style={{ display: 'flex', alignItems: 'center', gap: '6px', color: 'var(--gold-primary)' }}><FiTag /> {blog.category}</span>
                <span style={{ display: 'flex', alignItems: 'center', gap: '6px' }}><FiCalendar /> {blog.date}</span>
              </div>

              <h1 className="blog-detail-title" style={{ color: 'var(--text-main)', fontSize: '2.2rem', marginBottom: '30px', lineHeight: '1.3' }}>{blog.title}</h1>

              {blog.image && (
                <div className="blog-detail-img-wrapper" style={{ width: '100%', maxHeight: '450px', overflow: 'hidden', borderRadius: '6px', marginBottom: '30px' }}>
                  <img src={blog.image} alt={blog.title} style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
                </div>
              )}

              <div className="blog-detail-content" style={{ color: 'var(--text-muted)', fontSize: '1.05rem', lineHeight: '1.8', whiteSpace: 'pre-line' }}>
                {blog.content}
              </div>

            </article>
          )}

        </div>
      </div>

      <Footer />
    </div>
  );
}

export default BlogDetail;